import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4-mini';

import { OidcCallbackPage } from '$/pages/OidcPages/pages/OidcCallbackPage';
import { OidcLoginPage } from '$/pages/OidcPages/pages/OidcLoginPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';

export const OidcLoginRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/oidc/login',
  component: OidcLoginPage,
});

export const OidcCallbackRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/oidc/callback',
  component: OidcCallbackPage,
  validateSearch: z.object({
    code: z.optional(z.string()),
  }),
});
